var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('h4',[_vm._v("Разделы")]),(!_vm.isEmpty(_vm.storedRoutes))?_c('ul',{staticClass:"menu text-muted"},_vm._l((_vm.navRoutes),function(item){return _c('nav-tree-item',{key:item.id || item.linkTo,attrs:{"item":item}})}),1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }